export enum FileStatus {
    EMPTY= 'EMPTY',
    SELECTED= 'SELECTED',
    UPLOADED= 'UPLOADED'
}
